import { InlineAlert } from "@/components/application/alerts/inline-alert";

/**
 * UC-002 EUR Advisory Banner (Phase 16, REQ-BIZ-010 + princip #2).
 *
 * Render-only banner zobrazený, když `eur_advisory_flag === true` na detailu
 * rozpočtu. Říká adminovi, že daný měsíc obsahuje transakce v EUR (R-002
 * cross-currency dispenser) — částky se zobrazují paralelně v EUR i CZK
 * **bez FX přepočtu** (princip #2 source of truth = Axigon).
 *
 * Color-not-only (REQ-UI-018): Alert variant="info" + leading `i` icon.
 */

export interface EurAdvisoryBannerProps {
  /** Pokud `false` → komponent nerenderuje nic. */
  visible: boolean;
  /** Volitelný počet EUR transakcí v měsíci (admin context). */
  eurTransactionCount?: number;
  /** Volitelný název Střediska (zóny). */
  billingGroupCode?: string;
}

export function EurAdvisoryBanner({
  visible,
  eurTransactionCount,
  billingGroupCode,
}: EurAdvisoryBannerProps) {
  if (!visible) return null;
  const countNote =
    typeof eurTransactionCount === "number" && eurTransactionCount > 0
      ? ` (${eurTransactionCount} EUR transakcí)`
      : "";
  const zoneNote = billingGroupCode ? ` ve Středisku ${billingGroupCode}` : "";
  return (
    <div data-testid="budget-eur-advisory">
      <InlineAlert variant="info" title="EUR transakce v měsíci (orientačně)">
        <p>
          Měsíc obsahuje transakce v EUR{zoneNote}{countNote}. Částky se
          zobrazují <strong>paralelně v EUR a CZK z Axigonu</strong> — žádný
          přepočet. Axigon zůstává jediným zdrojem pravdy (source of truth).
        </p>
      </InlineAlert>
    </div>
  );
}
